import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CategorypagesPage } from './categorypages';

@NgModule({
  declarations: [
    CategorypagesPage,
  ],
  imports: [
    IonicPageModule.forChild(CategorypagesPage),
  ],
})
export class CategorypagesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/categorypages/categorypages.module.ts